(function (app, ng) {
    app.component("userOtherSettings",
        {
            controller: userOtherSettingsController,
            templateUrl: "/App/Dashboard/ConfigureAgentAccount/OtherSettings/template.html",
            bindings: {
                onSave: "&",
                user: "<",
                viewAsUserRoles: "<"
            }
        });

    userOtherSettingsController.$inject = ["$q", "userApi", "transactionGroupUserMemberApi", "transactionGroupApi", "$state", "$timeout", "prosperaSalesForceApi", "salesForceApi"];
    function userOtherSettingsController($q, userApi, transactionGroupUserMemberApi, transactionGroupApi, $state, $timeout, prosperaSalesForceApi, salesForceApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {
                    isSaving: false,
                    isClosing: false,
                    isLoading: false,
                    showSections: false
                },
                prospera: { edit: false, temp: {}, saved: {} },
                updateUserData: updateUserData,
                lookupProsperaAccountNumber: lookupProsperaAccountNumber,
                removePropseraSfAccount: removePropseraSfAccount
            });


        this.$onInit = function () {
            $ctrl.onSave({
                $func: function () {
                    return updateUserData();
                }
            });

            transactionGroupApi.getTransactionGroup($ctrl.user.TransactionGroupId).then(function (group) {
                $ctrl.userTransactionGroup = group;

                if ($ctrl.userTransactionGroup.Name === "Prospera") {
                    $ctrl.UI.showSections = true;

                    //lookup prospera advisor external salesforce account               
                    salesForceApi.getExternalSfAdvisor($ctrl.user.UserId).then(function (result) {

                        $ctrl.prospera.saved = {
                            AccountNumber: result.SfAccountNumber,
                            Name: result.SfAccountName,
                            AccountId: result.SfAccountId
                        };
                    }).catch(function (error) {
                        $ctrl.prospera.edit = true;
                    }
                    );
                };
            });
        };

        function removePropseraSfAccount() {
            salesForceApi.deleteExternalSfAdvisorRecord($ctrl.user.UserId).then(function () {
                $ctrl.prospera = { edit: true, temp: {}, saved: {} };
            });
        }

        function lookupProsperaAccountNumber() {
            $ctrl.UI.isLoading = true;
            $ctrl.prospera.temp.NotFound = false;
            prosperaSalesForceApi.lookupAdvisorSf($ctrl.prospera.temp.AccountNumber).then(function (result) {

                if (result.records.length > 0) {
                    $ctrl.prospera.temp.AccountNumber = result.records[0].AccountNumber;
                    $ctrl.prospera.temp.AccountId = result.records[0].Id;
                    $ctrl.prospera.temp.Name = result.records[0].Name;

                } else {
                    $ctrl.prospera.temp.NotFound = true;
                }

                $ctrl.UI.isLoading = false;
            });
        }

        function updateUserData() {
            var promises = [];

            if ($ctrl.userTransactionGroup.Name === "Prospera" && $ctrl.prospera.edit) {
                var agentRecord = {
                    UserId: $ctrl.user.UserId,
                    SfAccountName: $ctrl.prospera.temp.Name,
                    SfAccountId: $ctrl.prospera.temp.AccountId,
                    SfAccountNumber: $ctrl.prospera.temp.AccountNumber,
                    ExternalSfEntity: "Prospera"
                }

                promises.push(salesForceApi.getExternalSfAdvisor($ctrl.user.UserId).then(function (result) {
                    salesForceApi.updateExternalSfAdvisorRecord(agentRecord).then(function () {
                        $ctrl.prospera.edit = false;
                        $ctrl.prospera.temp = {};
                        $ctrl.prospera.saved = {
                            AccountNumber: agentRecord.SfAccountNumber,
                            Name: agentRecord.SfAccountName,
                            AccountId: agentRecord.SfAccountId
                        };
                    });
                }).catch(function (x) {  //doesn't exist                 
                    salesForceApi.createExternalSfAdvisorRecord(agentRecord).then(function (result) {
                        $ctrl.prospera.edit = false;
                        $ctrl.prospera.temp = {};
                        $ctrl.prospera.saved = {
                            AccountNumber: result.SfAccountNumber,
                            Name: result.SfAccountName,
                            AccountId: result.SfAccountId
                        };

                    });
                }
                ));

            }

            return $q.all(promises);
        }
    }
})(window.app, window.angular); //jshint ignore:line